import { atom } from 'jotai';

export type SearchHelperFilterState = {
  selectedAge: number; // 0 = 전체
  ageFilters: {
    name: string;
    value: number;
  }[];
};

export const searchHelperFilterAtom = atom<SearchHelperFilterState>({
  selectedAge: 0,
  ageFilters: [],
});
